module.exports = __webpack_public_path__ + "static/media/partner9.e9b7fdb0.jpg";